import { ItemSkeleton } from './ItemSkeleton';

export const LoadingState = () => {
  return (
    <div role="list" className="grid auto-rows-min grid-cols-1 gap-x0_5">
      <ItemSkeleton />
      <ItemSkeleton />
      <ItemSkeleton />
      <ItemSkeleton />
      <ItemSkeleton />
      <ItemSkeleton />
      <ItemSkeleton />
      <ItemSkeleton />
    </div>
  );
};
